import { call, put } from 'redux-saga/effects';

import * as types from './kpi-row.types';
import * as actions from './kpi-row.actions';
import { select, selectWithParams } from '../../../utils/selector.utils';
import { kpiRowSelectors } from './kpi-row.selectors';
import { scoreSelectors } from '../score/score.selectors';
import { IScore } from '../score/score.types';
import { storeScore } from '../score/score.actions';
import { IMeeting } from '../meeting/meeting.types';
import { IKpi } from '../kpi/kpi.types';
import { IMeetingSimple } from '../meeting-simple/meeting-simple.types';
import { meetingSimpleSelectors } from '../meeting-simple/meeting-simple.selectors';
import { kpiSelectors } from '../kpi/kpi.selectors';
import * as kpiService from '../kpi/kpi.saga-service';

export function* storeKpiRow(storeKpiRow: types.IKpiRow | types.IKpiRow[]) {
  yield put(actions.storeKpiRow(storeKpiRow));
  return storeKpiRow;
}

export function* update(scoreIds: IScore['id'][]) {
  const scores = (yield selectWithParams(scoreSelectors.selectResourcesById, scoreIds)) as IScore[];
  if (!scores) {
    return;
  }
  const newScores = [...scores] as IScore[];

  // any score should have its related meetingId and it should exist
  const meetingId: IMeeting['id'] = newScores[0]['meetingId'];

  const meeting = (yield selectWithParams(
    meetingSimpleSelectors.selectResourceById,
    meetingId ?? '',
  )) as IMeetingSimple;
  if (!meeting || !meeting.kpiId) {
    return;
  }

  const kpi = (yield selectWithParams(kpiSelectors.selectResourceById, meeting.kpiId)) as IKpi;
  kpi.kpiRowIds = newScores.map((score) => score.id);
  yield call(kpiService.storeKpi, kpi);

  newScores.forEach((score: IScore, index) => (score.sort = String(index)));
  yield put(storeScore(newScores));
}

export function* clearKpiRow(kpiRowId: types.IKpiRow['id']) {
  yield put(actions.clearKpiRow(kpiRowId));
}

export function* clearAllKpiRows() {
  const kpiRowIds: types.IKpiRow['id'][] = yield select(kpiRowSelectors.selectResourceIds);
  yield put(actions.clearKpiRow(kpiRowIds));
}
